import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization, UserJWT } = {}) =>
  jwt || Authorization || UserJWT || "";

const toIsoTimestamp = (date) => {
  if (!date) return "";

  return new Date(date).toISOString().slice(0, 19);
};

const toJavaTimestamp = (date) => {
  if (!date) return "";

  const d = new Date(date);

  const pad = (n) => n.toString().padStart(2, "0");

  return (
    d.getFullYear() +
    "-" +
    pad(d.getMonth() + 1) +
    "-" +
    pad(d.getDate()) +
    " " +
    pad(d.getHours()) +
    ":" +
    pad(d.getMinutes()) +
    ":" +
    pad(d.getSeconds())
  );
};

const companyController = {
  getCompanyEmployees: ({
    companyId,
    page = 1,
    size = 10,
    jwt,
    Authorization,
    search,
  }) => {
    const params = new URLSearchParams();

    if (companyId) params.append("companyId", companyId);
    params.append("page", page);

    if (search) params.append("search", search);

    params.append("size", size);

    return Utils.controller(
      "api/company/v1/companyEmployees",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  userPrimaryCompanies: ({ Authorization, userId }) => {
    return Utils.controller(
      "api/company/v1/userPrimaryCompanies",
      "",
      "GET",
      `userId=${userId}`,
      true,
      Authorization,
      true,
    );
  },

  addCompanyEmployees: ({ addCompanyEmloyeeRequest, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/addCompanyEmployee",
      addCompanyEmloyeeRequest,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getBusinesProfileCompanies: ({ businessProfileID, Authorization }) => {
    return Utils.controller(
      "api/businessProfile/v1/getBusinessProfileCompanies",
      "",
      "POST",
      `businessProfileID=${businessProfileID}`,
      true,
      Authorization,
      true,
    );
  },

  CompanyRegistration: ({
    companyRegisterRequest,
    CompanyRegistraterDTO,
    Authorization,
    UserJWT,
  }) => {
    return Utils.controller(
      "api/company/v1/companyRegistration",
      companyRegisterRequest || CompanyRegistraterDTO,
      "POST",
      "",
      true,
      getAuth({ Authorization, UserJWT }),
      true,
    );
  },

  addCompanyAddress: ({ addCompanyAddressRequest, Authorization, jwt }) => {
    return Utils.controller(
      "api/company/v1/addCompanyAddress",
      addCompanyAddressRequest,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  updateAddCompanyAttachments: ({ addAttachments, Authorization }) => {
    return Utils.controller(
      "api/company/v1/updateCompanyAttachments",
      addAttachments,
      "PUT",
      "",
      true,
      Authorization,
      true,
    );
  },

  updateCompanyDescription: ({ companyDescription, Authorization, jwt }) => {
    return Utils.controller(
      "api/company/v1/updateCompanyDescription",
      companyDescription,
      "PUT",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  updatecompanydetails: ({ updateDetails, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/updateCompnayDetails",
      updateDetails,
      "PUT",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  deleteCompanyEmployee: ({ removeEmployeeRequestDTO, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/deleteCompanyEmployee",
      removeEmployeeRequestDTO,
      "DELETE",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  toggleEnfroceMFA: ({ companyID, jwt }) => {
    return Utils.controller(
      "api/company/v1/toggleEnfrocemfa",
      "",
      "POST",
      `companyID=${companyID}`,
      true,
      getAuth({ jwt }),
      true,
    );
  },

  updateCompanyAttachmentStatus: ({ attachments, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/updateCompanyAttachmentStatus",
      attachments,
      "PUT",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getCompanyDetails: ({ copmayRequest, Authorization, jwt }) => {
    return Utils.controller(
      "api/company/v1/getCompanyDetails",
      copmayRequest,
      "POST",
      "",
      true,
      getAuth({ Authorization, jwt }),
      true,
    );
  },

  getCompanyRequests: ({
    businessType,
    page = 1,
    search,
    size = 10,
    status,
    jwt,
    Authorization,
  }) => {
    const params = new URLSearchParams();

    params.append("page", page);
    params.append("size", size);

    if (businessType) params.append("businessType", businessType);
    if (search) params.append("search", search);
    if (status) params.append("status", status);

    return Utils.controller(
      "api/company/v1/companyRequests",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  sendapprovedemail: ({ statusPayload, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/approvedEmail",
      statusPayload,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  sendResubmissionEmail: ({ statusPayload, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/resubmissionEmail",
      statusPayload,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  sendrejectedemail: ({ statusPayload, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/rejectedEmail",
      statusPayload,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  toggleVerifyTaxNumber: ({ request, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/toggleVerifyTaxNumber",
      request,
      "PUT",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  updateTaxNumber: ({ updateTaxNb, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/updateTaxNumber",
      updateTaxNb,
      "PUT",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  // =========================================================
  // COMPANY / DRIVER QR CODE
  // Same API used by the mobile implementation.
  // =========================================================
  GetCompanyQrCode: ({ companyId, companyID, jwt, Authorization, UserJWT }) => {
    const params = new URLSearchParams();

    const resolvedCompanyId = companyId || companyID;

    if (resolvedCompanyId) {
      params.append("companyId", resolvedCompanyId);
    }

    return Utils.controller(
      "api/company/v1/qr-code",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization, UserJWT }),
      true,
      "*/*",
    );
  },

  addProduct: ({ productRequestDto, Authorization }) => {
    return Utils.controller(
      "api/product/v1/addProduct",
      productRequestDto,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  QrCodeRequests: ({
    companyId,
    companyName,
    fromDate,
    page,
    qrCodeStatus,
    search,
    size,
    toDate,
    Authorization,
  }) => {
    const params = new URLSearchParams();

    if (companyId) params.append("companyId", companyId);
    if (companyName) params.append("companyName", companyName);
    if (fromDate) params.append("fromDate", fromDate);
    if (page !== undefined) params.append("page", page);
    if (qrCodeStatus) params.append("qrCodeStatus", qrCodeStatus);
    if (search) params.append("search", search);
    if (size !== undefined) params.append("size", size);
    if (toDate) params.append("toDate", toDate);

    const queryString = params.toString();

    return Utils.controller(
      "api/qrcodes/v1/qrCodeRequests",
      "",
      "GET",
      queryString,
      true,
      Authorization,
      true,
    );
  },

  getQuickActions: ({ Authorization, companyId }) => {
    return Utils.controller(
      "api/product/v1/getQuickActions",
      "",
      "PUT",
      `companyId=${companyId}`,
      true,
      Authorization,
      true,
    );
  },

  QrBulkJobs: ({ req, Authorization }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs",
      req,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  QrBulkpause: ({ jobId, Authorization }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs/pause",
      "",
      "POST",
      `jobId=${jobId}`,
      true,
      Authorization,
      true,
    );
  },

  QrBulkResume: ({ jobId, Authorization }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs/resume",
      "",
      "POST",
      `jobId=${jobId}`,
      true,
      Authorization,
      true,
    );
  },

  QrBulkCancel: ({ jobId, Authorization }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs/cancel",
      "",
      "POST",
      `jobId=${jobId}`,
      true,
      Authorization,
      true,
    );
  },

  QrBulkRetyFailed: ({ jobId, Authorization }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs/retry-failed",
      "",
      "POST",
      `jobId=${jobId}`,
      true,
      Authorization,
      true,
    );
  },

  QrBulkJobsStatus: ({ jobId, Authorization }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs",
      "",
      "GET",
      `jobId=${jobId}`,
      true,
      Authorization,
      true,
    );
  },
};

export default companyController;
